import type { InstallationType } from "@/base/sensor-configurations"
import React from "react"
import { StyleSheet } from "react-native"

import { formatInstallationType } from "@/base/sensor-configurations"
import {
  AppText,
  COLORS,
  getIconForInstallationType,
  RADII,
  SPACING,
  useIsDarkMode,
  View,
} from "@/theme"
import { renderIconFromIconProp } from "@/theme/icons/renderIconFromIconProp"

import type { AppIconProps, AppTextProps, ViewProps } from "@/theme"

const styles = StyleSheet.create({
  root: {
    alignItems: "center",
    borderColor: COLORS.$divider.light,
    borderRadius: RADII.$default,
    borderWidth: 1,
    display: "flex",
    flexDirection: "row",
    marginRight: "auto",
    padding: 2,
    paddingHorizontal: SPACING.$2,
  },
  text: {
    marginLeft: SPACING.$1,
  },
})

export interface InstallationTypeIndicatorProps extends ViewProps {
  value: InstallationType
}

export function InstallationTypeIndicator({
  value = "unconfigured",
  ...rest
}: InstallationTypeIndicatorProps): React.JSX.Element | null {
  const isDark = useIsDarkMode()
  let backgroundColor: string | undefined = COLORS.$paper.light
  let textColorScheme: AppTextProps["colorScheme"] = "secondary"
  let iconColor: AppIconProps["color"] | undefined = undefined

  if (isDark) {
    backgroundColor = COLORS.$paper.dark
  }

  if (value === "unconfigured") {
    backgroundColor = COLORS.$warning[300]
    textColorScheme = "darkText"
    iconColor = COLORS.$textDark.secondary
  }

  const text = formatInstallationType(value)
  return (
    <View
      id={"installationTypeIndicator"}
      style={[styles.root, { backgroundColor }]}
      {...rest}
    >
      {renderIconFromIconProp(getIconForInstallationType(value), {
        color: iconColor,
      })}
      <AppText
        colorScheme={textColorScheme}
        fontSize={"$sm"}
        style={styles.text}
      >
        {text}
      </AppText>
    </View>
  )
}
